export const generateName = (generator) => generator();

export const getCheckedFromValue = (value) => {
  if (value) return 'checked';
  return false;
};
